module.exports = __webpack_public_path__ + "img/CalendarioConsultas.740dcff6.png";